import BaseChartOptions from "../../../utils/BaseChart/BaseChartOptions";

class LineChartOptions extends BaseChartOptions{
    constructor(data: Array<any>, lineIDs: string[]) {
        super(data);
        this.setChildren(
            lineIDs.map(id => ({ id, type: "line"})))
    }
}

export default LineChartOptions;